const prefetchLinks = () : void => {

    const prefetchLinks: string[] = [];

    function prefetch(event: MouseEvent) {
        const element = event.target;
        if (! (element instanceof HTMLAnchorElement)) {
            return;
        }

        element.removeEventListener('mouseover', prefetch as EventListenerOrEventListenerObject);
        const href = element.getAttribute('href') as string;
        if (prefetchLinks.includes(href)) {
            return;
        }

        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = href;
        document.body.appendChild(link);
        prefetchLinks.push(href);
    }

    const url = 'https://' + top?.location.host.toString();
    document.querySelectorAll(`a[href^="${url}"]`).forEach(a => a.addEventListener('mouseover', prefetch as EventListenerOrEventListenerObject));

}
export default prefetchLinks;
